export default __webpack_public_path__ + "static/media/TheAlternativeLendingReport_Middlemarch.ec9ef1da.pdf";